import { useMutation } from '@tanstack/react-query'
import { FormikHelpers } from 'formik'

import { useHandleApiError } from '../../../../hooks/useHandleApiError'
import useNotyf from '../../../../hooks/useNotyf'
import referralLinkService from '../../../../lib/services/referralLinkService'
import { EditCalendarCodeFormValues } from '../../../../pages/emailAndCalendarIntegration/components/ShareableLinks/constants'
import { UpdateReferralLinkCodeRequest } from '../../../../types/requests/referral-links'
import { useInvalidateReferralLinksQueries } from './useInvalidateReferralLinksQueries'

interface MutationVariables {
  existingReferralLinkCode: string
  request: UpdateReferralLinkCodeRequest
  formikHelpers: FormikHelpers<EditCalendarCodeFormValues>
}

export function useUpdateCalendarLinkCodeMutation() {
  const notyf = useNotyf()
  const invalidateReferralLinksQueries = useInvalidateReferralLinksQueries()
  const { handleApiError } = useHandleApiError()

  return useMutation({
    mutationFn: ({ existingReferralLinkCode, request }: MutationVariables) =>
      referralLinkService.updateReferralLinkCode(
        existingReferralLinkCode,
        request,
      ),
    onSuccess: async (_response) => {
      await invalidateReferralLinksQueries()

      notyf.success('Calendar link code updated successfully')
    },
    onError: (error, { formikHelpers }) => {
      handleApiError({ error, formikHelpers })
    },
  })
}
